import { Features } from 'generated/featureDefinitions'

import type { CommunitiesDropdown } from 'modules/dashboard/components/Groups/types'
import groups from 'modules/dashboard/store/collections/communities/Groups'
import type Group from 'modules/dashboard/store/models/communities/Group'
import { useEngagementFeatureAvailability } from 'modules/engagement/hooks/useEngagementFeatureAvailability'

export function useShowKudosCard({
  group,
  communitiesDropdown,
}: {
  communitiesDropdown: CommunitiesDropdown
  group?: Group
}) {
  const groupToCheck = group ?? groups.find({ id: communitiesDropdown.value })

  const hasKudosFeatureFlagEnabled = useEngagementFeatureAvailability(Features.communities_claps)

  return hasKudosFeatureFlagEnabled && isKudoableView()

  function isKudoableView(): boolean {
    switch (viewKind()) {
      case 'kudo':
      case 'all': {
        return canPostToAnyGroup()
      }
      case 'group': {
        return Boolean(groupToCheck?.policy.can('addPostsPosts'))
      }
      default: {
        return false
      }
    }
  }

  function viewKind() {
    const { value, strategy } = communitiesDropdown
    switch (strategy) {
      case 'type': {
        return String(value).toLowerCase()
      }
      case 'all': {
        return 'all'
      }
      case 'group': {
        return 'group'
      }
      default: {
        throw new Error('Unkwon strategy')
      }
    }
  }

  function canPostToAnyGroup() {
    return groups.filter((groupToFilter) => groupToFilter.policy.can('addPostsPosts')).length > 0
  }
}
